import { render, staticRenderFns } from "./analysis-mental-health.vue?vue&type=template&id=914aa9ea&scoped=true&"
import script from "./analysis-mental-health.vue?vue&type=script&lang=js&"
export * from "./analysis-mental-health.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "914aa9ea",
  null
  
)

export default component.exports